import UserStatusBadge from "./UserStatusBadge";

import Button from "../../../components/common/Button";

const ROLE_CONFIG = {
  ADMIN: {
    label: "Admin",
    className: "role-badge-admin"
  },

  SALES: {
    label: "Sales",
    className: "role-badge-sales"
  },

  AGENT: {
    label: "Agent",
    className: "role-badge-agent"
  }
};

const RoleBadge = ({ role }) => {
  const config =
    ROLE_CONFIG[role] || {
      label: role,
      className: "role-badge-default"
    };

  return (
    <span className={`role-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

const UserTable = ({
  users = [],
  loading = false,
  onEdit,
  onChangePassword,
  onDelete,
  onView
}) => {
  if (loading) {
    return (
      <div className="user-table-container">
        <div className="user-table-loading">
          <div className="loading-spinner" />
          <span>Loading users...</span>
        </div>
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <div className="user-table-container">
        <div className="user-table-empty">
          <div className="empty-state-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />

              <circle
                cx="9"
                cy="7"
                r="4"
              />

              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />

              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>

          <h3>No users found</h3>

          <p>
            There are currently no managed users.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-table-container">
      {/* DESKTOP TABLE */}
      <div className="user-table-desktop">
        <table className="user-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Contact</th>
              <th>Role</th>
              <th>Status</th>
              <th className="table-actions-header">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>
                  <div className="table-user">
                    <div className="table-user-avatar">
                      {user.name
                        ?.charAt(0)
                        ?.toUpperCase()}
                    </div>

                    <div className="table-user-info">
                      <div className="table-user-name">
                        {user.name}
                      </div>

                      <div className="table-user-email">
                        {user.email}
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <span className="table-phone">
                    {user.phone || "—"}
                  </span>
                </td>

                <td>
                  <div className="role-list">
                    {user.roles?.length ? (
                      user.roles.map((role) => (
                        <RoleBadge
                          key={role}
                          role={role}
                        />
                      ))
                    ) : (
                      <span className="table-muted">
                        —
                      </span>
                    )}
                  </div>
                </td>

                <td>
                  <UserStatusBadge
                    status={user.status}
                  />
                </td>

                <td>
                  <div className="table-actions">
                    {onView && (
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => onView(user)}
                      >
                        View
                      </Button>
                    )}

                    {onEdit && (
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => onEdit(user)}
                      >
                        Edit
                      </Button>
                    )}

                    {onChangePassword && (
                      <Button
                        size="sm"
                        variant="ghost"
                        onClick={() =>
                          onChangePassword(user)
                        }
                      >
                        Password
                      </Button>
                    )}

                    {onDelete && (
                      <Button
                        size="sm"
                        variant="danger"
                        onClick={() => onDelete(user)}
                      >
                        Deactivate
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MOBILE CARDS */}
      <div className="user-table-mobile">
        {users.map((user) => (
          <div
            key={user.id}
            className="mobile-user-card"
          >
            <div className="mobile-user-header">
              <div className="table-user">
                <div className="table-user-avatar">
                  {user.name
                    ?.charAt(0)
                    ?.toUpperCase()}
                </div>

                <div className="table-user-info">
                  <p className="table-user-name">
                    {user.name}
                  </p>

                  <p className="table-user-email">
                    {user.email}
                  </p>
                </div>
              </div>

              <UserStatusBadge
                status={user.status}
              />
            </div>

            <div className="mobile-user-details">
              <div>
                <span>Phone</span>
                <strong>
                  {user.phone || "—"}
                </strong>
              </div>

              <div>
                <span>Role</span>

                <div className="role-list">
                  {user.roles?.map((role) => (
                    <RoleBadge
                      key={role}
                      role={role}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="mobile-user-actions">
              {onView && (
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => onView(user)}
                >
                  View
                </Button>
              )}

              {onEdit && (
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => onEdit(user)}
                >
                  Edit
                </Button>
              )}

              {onChangePassword && (
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() =>
                    onChangePassword(user)
                  }
                >
                  Password
                </Button>
              )}

              {onDelete && (
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => onDelete(user)}
                >
                  Deactivate
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserTable;